(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5301],{

/***/ 65301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content062": function() { return /* binding */ Content062; },
  "default": function() { return /* binding */ Content062_Content062; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./src/components/widgets/content/Content062/Content062.module.scss
var Content062_module = __webpack_require__(9708);
var Content062_module_default = /*#__PURE__*/__webpack_require__.n(Content062_module);
// EXTERNAL MODULE: ./src/components/widgets/content/Content062/Item/Item.module.scss
var Item_module = __webpack_require__(64438);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content062/Item/Item.jsx



var Item = function(param) {
    var title = param.title, attachmentButtonText = param.attachmentButtonText, file = param.file;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Item_module_default()).content,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                className: (Item_module_default()).file,
                name: "file"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                className: (Item_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DownloadFile */.xn, {
                file: file,
                label: attachmentButtonText,
                icon: "arrow_right",
                color: "blue",
                className: (Item_module_default()).label
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content062/Item/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content062/Content062.jsx









var Content062 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var attachments = (ref1 = payload === null || payload === void 0 ? void 0 : payload.attachments) !== null && ref1 !== void 0 ? ref1 : [];
    var prevRef = (0,react.useRef)(null);
    var nextRef = (0,react.useRef)(null);
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Content062_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Content062_module_default()).block,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                            className: (Content062_module_default()).title,
                            children: title
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Content062_module_default())["navigation-wrapper"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Content062_module_default())["slider-navigation"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: prevRef,
                                        className: classnames_default()((Content062_module_default()).navigation, (Content062_module_default())["navigation-prev"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: (Content062_module_default()).icon,
                                            name: "arrow_slider_prev"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: nextRef,
                                        className: classnames_default()((Content062_module_default()).navigation, (Content062_module_default())["navigation-next"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: (Content062_module_default()).icon,
                                            name: "arrow_slider_next"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content062_module_default()).slider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SwiperLayout */.OJ, {
                    prevRef: prevRef,
                    nextRef: nextRef,
                    watchOverflow: false,
                    slidesPerView: "auto",
                    spaceBetween: 6,
                    slidesPerGroup: 1,
                    slidesOffsetAfter: 30,
                    children: attachments.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: (Content062_module_default()).slide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, (0,_object_spread/* default */.Z)({
                                className: (Content062_module_default()).item
                            }, item))
                        }, item.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Content062_Content062 = (Content062);


/***/ }),

/***/ 9708:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content062_wrapper__937mf","block":"Content062_block__twHN_","title":"Content062_title__JMI4V","slider":"Content062_slider__FPLpD","slider-navigation":"Content062_slider-navigation__7oRe1","navigation":"Content062_navigation__CD_iL","navigation-prev":"Content062_navigation-prev__rCUSI","navigation-next":"Content062_navigation-next__4_0IY","slide":"Content062_slide__Cbui0"};

/***/ }),

/***/ 64438:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"Item_content__Ld8pz","title":"Item_title__JOXlq","label":"Item_label__BWKbp","file":"Item_file__M_rVo"};

/***/ })

}]);